<template>
  <div ref="pool" class="pool">
    <div class="pool-title">
      <span class="pool-title-line pool-title-line__left"></span>
      <span class="pool-title-text bebas-font">{{ $bus.transify['LUCKY_HOME_GOODS_TITLE'] }}</span>
      <span class="pool-title-line pool-title-line__right"></span>
    </div>
    <ul class="pool-content">
      <li class="pool-item" v-for="(item, index) in $bus.rewardPool" :key="item.pk">
        <Item @click.native.stop="showName(index)"
          type="reward"
          :purchased="item.purchased"
          :nums="item.item_num"
          :imgSrc="item.item_img"
          :status="item.purchased">
          <ff-mark v-if="!$bus.animating && !item.purchased && $bus.enable !== -1" class="item-mask"
          :type="getType"
          points="15, 3 3, 15 3, 32 32, 3">
            <div class="mark-text" :class="getMarkTextClass">
              <i class="diamond"></i>
              <span class="text bebas-font">{{ getDiscountText }}</span>
            </div>
          </ff-mark>
          <template v-slot:mask-name>
            <div class="pool-item-name" @click.stop v-show="index === $bus.activeIndex">
              <span class="bebas-font">{{item.item_name}}</span>
            </div>
          </template>
        </Item>
        <div class="price-content price-content__pool">
          <!-- 折扣价 -->
          <div class="price" v-if="!item.purchased">
            <i class="diamond"></i>
            <span class="gems bebas-font">{{getPrice(item.price)}}</span>
          </div>
          <!-- 原价 -->
          <div class="init-price grey"
            v-if="!item.purchased && $bus.enable !== -1 && !$bus.animating">
            <span class="gems bebas-font">{{item.price}}</span>
          </div>
        </div>
        <ff-button class="pool-buy-btn" type="buy" :class="getBuyBtnClass(item)" @btnEvent="handlePurchase(item)">
          <span class="pool-buy-text bebas-font">{{ !item.purchased ? $bus.transify['LUCKY_PURCHASE'] : $bus.transify['LUCKY_PURCHASED'] }}</span>
        </ff-button>
      </li>
    </ul>
    <div class="pool-buttons">
      <ff-button type="pool" @btnEvent="showPrizePool">
        <div class="pool-info">
          <span class="pool-info-search"></span>
          <span class="pool-info-text">{{ $bus.transify['LUCKY_GOODS_BUTTON'] }}</span>
        </div>
      </ff-button>
      <ff-button class="pool-refresh"
        type="refresh" :breath="getBreath" :class="$bus.canRefresh && $bus.enable !== -1 && !$bus.animating ? 'active' : 'dark'"
        @btnEvent="handleRefresh">
        <div class="refresh-info">{{ $bus.transify['LUCKY_REFRESH'] }}</div>
      </ff-button>
      <div class="refresh-to-buy" v-if="getBreath">{{ $bus.transify['LUCKY_REFRESH_REMIND'] }}</div>
    </div>
    <div class="pool-refresh-tip">
      <div class="refresh-tip-content">
        <i class="diamond"></i>
        <span class="bebas-font refresh-tip-text">{{ getRefreshText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Item from '@/components/common/Item.vue'
import ffButton from '@/components/common/Button.vue'
import ffMark from '@/components/common/Mark.vue'
export default {
  components: {
    Item,
    ffButton,
    ffMark
  },
  computed: {
    getType () {
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0 ? 'light' : 'normal'
    },
    getMarkTextClass () {
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0 ? 'diamond-type' : ''
    },
    getDiscountText () {
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0 ? currentDiscount.discount : -currentDiscount.discount + '%'
    },
    getRefreshText () {
      return this.$bus.refreshFreeTimes > 0 ? this.$bus.transify['LUCKY_FREE'] : this.$bus.refreshCost
    },
    getBreath () {
      return this.$bus.rewardPool.every(item => item.purchased) && this.$bus.enable !== -1 && !this.$bus.animating
    }
  },
  methods: {
    getCurrentDiscount () {
      if (!this.$bus.discountPool || this.$bus.enable === -1) {
        return {}
      }
      return this.$bus.discountPool.find(item => item.pk === this.$bus.enable)
    },
    getBuyBtnClass (item) {
      if (item.purchased) {
        return 'blur'
      }
      return !this.$bus.animating && this.$bus.enable !== -1 ? 'active' : ''
    },
    getPrice (price) {
      if (this.$bus.enable === -1 || this.$bus.animating) {
        return price
      }
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0 ? currentDiscount.discount : Math.floor(price * (100 - currentDiscount.discount) / 100)
    },
    // 显示奖池
    showPrizePool () {
      if (this.$bus.animating) {
        return
      }
      this.$bus.addGA('show-all-products', 'click')
      this.$bus.productsDialog.show = true
    },
    showName (idx) {
      if (this.$bus.animating) {
        return
      }
      this.$bus.clickSound = true
      this.$bus.activeIndex = idx
    },
    // 刷新逻辑
    handleRefresh () {
      if (this.$bus.animating) {
        return
      }
      // 抽奖结束
      if (this.$bus.finish === 1) {
        return
      }
      // 不可刷新
      if (!this.$bus.canRefresh) {
        this.$bus.handleToast(true, 'LUCKY_REFRESH_REMINDER')
        return
      }
      // 未抽取折扣
      if (this.$bus.enable === -1) {
        this.$bus.handleToast(true, 'LUCKY_DRAW_REMINDER')
        return
      }

      // 当钻石不足
      if (this.$bus.gems < this.$bus.refreshCost && this.$bus.refreshFreeTimes <= 0) {
        this.$bus.handleToast(true, 'TOAST_GEM_NOT_ENOUGH')
        return
      }

      const refreshFreeTimes = this.$bus.refreshFreeTimes
      const cost = refreshFreeTimes > 0 ? 0 : this.$bus.refreshCost
      // 判断是否有免费次数
      if (refreshFreeTimes <= 0) {
        this.$bus.refreshNotice ? this.$bus.confirmDialog = {
          show: true,
          type: 'refresh'
        } : this.$bus.refresh(cost)
      } else {
        this.$bus.refresh(cost)
      }
    },
    // 购买
    handlePurchase (item) {
      if (item.purchased || this.$bus.animating) {
        return
      }
      // 若还未抽取折扣
      if (this.$bus.enable === -1) {
        this.$bus.handleToast(true, 'LUCKY_DRAW_REMINDER')
        return
      }
      if (this.$bus.gems < this.getPrice(item.price)) {
        this.$bus.handleToast(true, 'TOAST_GEM_NOT_ENOUGH')
        return
      }
      this.$bus.activePrize = this.$bus.rewardPool.find(ele => ele.pk === item.pk)
      this.$bus.buyDialog.show = true
      this.$bus.addGA('show-purchase-dialog', 'click')
    }
  },
  mounted () {
    this.$nextTick(() => {
      let [listWidth, listHeight, ClientRect] = [
        this.$refs.pool.offsetWidth,
        this.$refs.pool.offsetHeight,
        this.$refs.pool.getBoundingClientRect()
      ]
      this.$bus.discountDinate.top = ClientRect.top + Math.floor(listHeight / 2)
      this.$bus.discountDinate.left = ClientRect.left + Math.floor(listWidth / 2)

      window.addEventListener('resize', () => {
        let [listWidth, listHeight, ClientRect] = [
          this.$refs.pool.offsetWidth,
          this.$refs.pool.offsetHeight,
          this.$refs.pool.getBoundingClientRect()
        ]
        this.$bus.discountDinate.top = ClientRect.top + Math.floor(listHeight / 2)
        this.$bus.discountDinate.left = ClientRect.left + Math.floor(listWidth / 2)
      }, false)
    })
  }
}
</script>

<style lang="scss" scoped>
.pool {
  @include px2res(width, 684);
  @include px2res(height, 594);
  @include px2res(padding, 22, 20, 0);
  @include px2res(margin, 42, 0, 0);
  text-transform: uppercase;

  .pool-title {
    @include flexrc;
    @include px2res(padding-bottom, 10);
  }

  .pool-title-text {
    @include px2res(padding, 0, 26);
    @include px2res(font-size, 25);
    @include text-gradient(#d1d7dc 0%, #8e9ab0 100%);
  }

  .pool-title-line {
    @include px2res(width, 195);
    height: 2px;
  }
}
.pool-content {
  width: 100%;
  @include flexrc;
  flex-wrap: wrap;
}
.pool-item {
  position: relative;
  @include px2res(width, 116);
  @include px2res(margin, 0, 22, 24);
}
.pool-buy-btn.grey {
  color: #fff;
}
.pool-buy-text {
  @include px2res(height, 32);
  @include px2res(line-height, 34);
}
.pool-item-name {
  position: absolute;
  top: 30%;
  right: 50%;
  z-index: 99;
  transform: translate(0, -50%);
  @include px2res(padding, 5, 20);
  @include px2res(font-size, 16);
  @include px2res(min-width, 100);
  letter-spacing: .5px;
  white-space: nowrap;;
  border: 1px solid #deaa44;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
  line-height: 1;
  background-color: #080707;
  text-align: center;
  font-style: italic;
  animation: nameIn .3s ease-out both;
}
.mark-text {
  top: 18%;
  left: 10%;
  @include px2res(width, 74);
  @include px2res(height, 30);
  .diamond {
    @include px2res(margin-right, 2);
  }
}
.price-content__pool {
  flex-direction: row;

  .price .gems {
    @include px2res(padding-right, 8);
  }
}
.pool-buttons {
  position: relative;
  display: flex;
  /* @include px2res(padding-top, 10); */

  .refresh-to-buy {
    position: absolute;
    top: -95%;
    right: 0;
    @include px2res(padding, 12, 30, 20);
    @include px2res(font-size, 18);
  }
}
.pool-refresh-tip {
  display: flex;
  justify-content: flex-end;
  @include px2res(padding-right, 26);

  .refresh-tip-content {
    @include flexrc;
    @include px2res(width, 270);
  }

  .diamond {
    @include px2res(width, 14);
    @include px2res(height, 14);
  }

  .refresh-tip-text {
    @include px2res(padding-left, 4);
    color: #b8b8b8;
    @include px2res(font-size, 24);
  }
}
.pool-info {
  @include flexrc;

  .pool-info-search {
    @include px2res(width, 24);
    @include px2res(height, 24);
  }

  .pool-info-text {
    @include px2res(padding-left, 12);
    @include px2res(font-size, 32);
    @include text-gradient(180deg,#774000 0%, #944e00 100%);
  }
}
.pool-refresh.dark {
  .refresh-info {
    filter: grayscale(1);
  }
}
.refresh-info {
  @include flexrc;
  color: #003840;
}
.refresh-text {
  @include flexrc;
}
.refresh-tip {
  text-shadow: 1px 0px 0px rgba(0, 0, 0, .1);
  background:linear-gradient(0deg,rgba(0,56,64,1) 0%, rgba(0,105,120,1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.refresh-tip.done {
  height: auto;
}
.refresh-cost {
  @include flexrc;
  @include px2res(font-size, 30);
  @include px2res(margin-left, 22);
  align-items: flex-end;
  .diamond {
    @include px2res(width, 21);
    @include px2res(height, 19);
  }
  .cost-nums {
    @include px2res(height, 27);
    @include px2res(margin-left, 2);
  }
  .cost-nums.free-text {
    @include px2res(font-size, 28);
  }
}
.refresh-times {
  @include px2res(font-size, 30);
  font-style: italic;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/pool/index.vue